import styled from 'styled-components'

export const ContainerComments = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;

  padding-top: 25px;
`

export const ContainerItem = styled.div<{ isEven?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 40px;
  padding-right: 40px;
  color: ${({ theme }) => theme.colors.gray};
  background: ${({ isEven }) => (isEven ? '#f0e9e9' : null)};

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 178px;
    height: 50px;
  }
`
